export const jobDescriptionPrompt = `Generate a comprehensive and professional job description for the following position. 

IMPORTANT FORMATTING RULES:
1. Use HTML only, NOT markdown
2. Use <strong> for bold (NOT ** asterisks)
3. Use <ul> and <li> for bullet lists
4. Structure content with clear sections and consistent vertical spacing

CRITICAL — PARAGRAPH STRUCTURE (must follow):
- Each logical block MUST be its own <p>...</p>. Never put a section heading and its body text in the same <p>.
- For every section heading, use EXACTLY this pattern:
  <p><strong>Heading text</strong></p>
  <p>Body paragraph(s) for that section...</p>
- For lists, place the heading in its own <p>, then the list immediately after:
  <p><strong>Key Responsibilities</strong></p>
  <ul><li>...</li></ul>
- Between sections, rely on separate <p> tags — do NOT use multiple <br><br> as the only separator between a heading and the next paragraph. At most one <br> inside a <p> if needed; prefer new <p> elements.
- Do NOT place plain text on the same line as a closing </strong> inside one <p> (wrong: <p><strong>Job Overview</strong> Long text here...</p>). Always close the heading paragraph first, then open a new <p> for the body.

CRITICAL - START OF CONTENT:
- DO NOT start with "Job Title:" or any job title heading at the very beginning
- DO NOT include "About the Company" as a heading at the very beginning
- Start with one or more <p> paragraphs of introduction (no section heading for the opening)

REQUIRED SECTIONS (each heading in its own <p> as above):
- Job Overview — <p><strong>Job Overview</strong></p> then <p>...</p> with the overview text
- Key Responsibilities — then <ul><li>...</li></ul>
- Key Requirements (or Requirements) — then <ul><li>...</li></ul>
- Why Join Us / Benefits (recommended) — then <ul><li>...</li></ul> if applicable

The description should be well-structured, engaging, and cover:
1. Opening paragraph(s) with company context (no section heading)
2. Job Overview
3. Key Responsibilities (bullets)
4. Key Requirements (bullets)
5. Why Join Us / Benefits (bullets if applicable)

Keep it concise but comprehensive (around 300-500 words).

Return ONLY the HTML job description, no other text.`;
